class Product {
  constructor(data) {
    this.$originalData = Object.assign({}, data);
    const {
      id,
      name,
      price,
      sku,
      created_at,
      updated_at,
      purchase_instructions,
      sessiontypes,
      allow_partial_payment,
      deposit_required,
      deposit_type,
      deposit_amount,
      minimum_payment_amount,
    } = data;
    this.$id = id;
    this.$name = name;
    this.$price = price;
    this.$sku = sku;
    this.$created_at = created_at;
    this.$updated_at = updated_at;
    this.$session_types = sessiontypes;
    this.$purchase_instructions = purchase_instructions;
    this.$services = [];

    this.$allow_partial_payment = allow_partial_payment || false;
    this.$deposit_required = deposit_required || null;
    this.$deposit_type = deposit_type || null;
    this.$deposit_amount = deposit_amount || null;
    this.$minimum_payment_amount = minimum_payment_amount || null;
  }

  /**
   * @return {number}
   */
  id() {
    return this.$id;
  }

  /**
   * @returns {string}
   */
  name() {
    return this.$name;
  }

  /**
   * @returns {number}
   */
  price() {
    return parseInt(this.$price);
  }

  /**
   * @returns {string}
   */
  priceInDollars() {
    return (this.price() / 100).toFixed(2).toString();
  }

  /**
   * @returns {string}
   */
  sku() {
    return this.$sku;
  }

  /**
   * @returns {string}
   */
  created_at() {
    return this.$created_at;
  }

  /**
   * @returns {string}
   */
  updated_at() {
    return this.$updated_at;
  }

  /**
   * @returns {string}
   */
  purchaseInstructions() {
    return this.$purchase_instructions;
  }

  /**
   * @returns {Array<Service>}
   */
  services() {
    return this.$services;
  }

  /**
   * @param {Array<Service>} services
   */
  setServices(services = []) {
    this.$services = services;
  }

  /**
   * @returns {boolean}
   */
  allowsPayLater() {
    return this.$allow_partial_payment;
  }

  /**
   * @returns {boolean}
   */
  requiresDeposit() {
    return this.$deposit_required;
  }

  /**
   * @returns {string}
   */
  depositType() {
    return this.$deposit_type;
  }

  /**
   * @returns {number}
   */
  depositAmount() {
    return this.$deposit_amount;
  }

  /**
   * @returns {number}
   */
  minimumPaymentAmount() {
    return this.$minimum_payment_amount;
  }

  /**
   * @param {number} amount
   * @returns {number}
   */
  calculateMinimumDepositRequired(amount) {
    if (this.allowsPayLater() === false) {
      return amount;
    }

    if (this.requiresDeposit() === false) {
      return 0;
    }

    if (this.depositType() === "fixed") {
      amount = this.depositAmount();
    }
    if (this.depositType() === "percentage") {
      amount = Math.round(parseFloat(amount * (this.depositAmount() / 100)));
    }

    return amount;
  }
}

export { Product };
